jQuery(document).ready(function(){
  "use strict";

  //GET CATEGORY NAME FOR COLLECTION PAGE AND PRODUCT PAGA
  var category_name = $('.breadcrumbs-category-name').html();
  if (typeof category_name !== typeof undefined && category_name !== '') {    
    $('.product-single .category-name').removeClass('hide');
    $('.product-single .category-name span').html(category_name);

    $('.s-header .category-name').removeClass('hide');
    $('.s-header .category-name span').html(category_name);
  }

  //BACK TO TOP
  $(window).scroll(function(){
    if ($(this).scrollTop() > 100) {
        $('#toTop').fadeIn();
    } else {
        $('#toTop').fadeOut();
    }
  });

  $('#toTop').click(function(){
      $('html, body').animate({scrollTop : 0},500);
      return false;
  });

  //OFFCANVAS
  $('.offcanvas-menu, .menu-overlay, .offcanvas-close').on('click', function(e) {
    e.preventDefault(); 
    $('body').toggleClass('build-menu-open');
  })  

  $(".modal-toggle").each( function(){
    $(this).on('click', function(e) {
        var id = $(this).attr('data-id');
        $('.modal-'+id).toggleClass('is-visible');
        e.preventDefault();        
    });
  });

  $('.modal-overlay, .model-close').on('click', function(e) {
    $('.modal').removeClass('is-visible');  
  });


  //QUANTITY BOX
  $('.qty-input:not(.disable)').one('click', function(e) {

      var input = $(this).parent().find('.cart__qty-input');

      var currentVal = parseInt(input.val());
      if (!isNaN(currentVal)) { 
        if($(this).hasClass('qty-plus')){
            input.val(currentVal + 1);
        } else{
            input.val(currentVal - 1);
        }
      } else{
        input.val(1);
      } 
    $( ".cart__submit-controls input[name='update']" ).trigger( "click" );
    e.preventDefault();      
  });  

  //FIX HEIGHT FOR PRODUCT NAME
  var maxHeight = -1;
  $('.grid-view-item .product-card__title span').each(function() {
      if ($(this).height() > maxHeight) {
          maxHeight = $(this).height();
      }
  });
  $('.grid-view-item .product-card__title span').css("height", maxHeight);

  $('.product_box .product_item .product-card__title span').each(function() {
      if ($(this).height() > maxHeight) {
          maxHeight = $(this).height();
      }
  });
  $('.product_box .product_item .product-card__title span').css("height", maxHeight);

  //CHECK CONTENT OF INFO BOX ON THE PRODUCT PAGE
  // $('.product-info-box-content').each(function() {
  //   if($(this).empty()){
  //     $(this).closest('.product-info-box').addClass('hide');
  //   } 
  // });
  

  //CONTACT PAGE
  $('.contact-form-submit').on('click', function(e) {
    
    var name1 = $("#ContactForm #ContactForm-name01").val();
    var name2 = $("#ContactForm #ContactForm-name02").val();
    var kana01 = $("#ContactForm #ContactForm-kana01").val();
    var kana02 = $("#ContactForm #ContactForm-kana02").val();
    var email1 = $("#ContactForm #ContactForm-email").val(); 
    var email2 = $("#ContactForm #ContactForm-email02").val();
    var contents = $("#ContactForm #ContactForm-contents").val();
    var check = true;
    var checkEmail = true;

    //CHECK NAME
    if(name1 !== typeof undefined && name1 !== ''){
      $('.check-name .error-1').addClass('hide');   
      $('.check-name #ContactForm-name01').removeClass('error');    
    } else {
      check = false;
      $('.check-name .error-1').removeClass('hide');    
      $('.check-name #ContactForm-name01').addClass('error');   
    }

    if(name2 !== typeof undefined && name2 !== ''){
      $('.check-name .error-2').addClass('hide');   
      $('.check-name #ContactForm-name02').removeClass('error');   
    } else {
      check = false;
      $('.check-name .error-2').removeClass('hide');    
      $('.check-name #ContactForm-name02').addClass('error');   
    }

    if(check){
      $('.check-name .attention').addClass('hide'); 
    } else{
      $('.check-name .attention').removeClass('hide');  
    }

    //CHECK KANA
    if(kana01 !== typeof undefined && kana01 !== ''){
      $('.check-kana .error-1').addClass('hide');   
      $('.check-kana #ContactForm-kana01').removeClass('error');    
    } else {
      check = false;
      $('.check-kana .error-1').removeClass('hide');    
      $('.check-kana #ContactForm-kana01').addClass('error');   
    }

    if(kana02 !== typeof undefined && kana02 !== ''){
      $('.check-kana .error-2').addClass('hide');   
      $('.check-kana #ContactForm-kana02').removeClass('error');   
    } else {
      check = false;
      $('.check-kana .error-2').removeClass('hide');    
      $('.check-kana #ContactForm-kana02').addClass('error');   
    }

    if(check){
      $('.check-kana .attention').addClass('hide'); 
    } else{
      $('.check-kana .attention').removeClass('hide');  
    }

    //CHECK EMAIL
    if(email1 !== typeof undefined && email1 !== ''){      

      if(IsEmail(email1)==false){
        check = false;
        checkEmail = false;
        $('.check-email .error-1').removeClass('hide');    
        $('.check-email #ContactForm-email').addClass('error');   
      } else{
        $('.check-email .error-1').addClass('hide');   
        $('.check-email #ContactForm-email').removeClass('error');        
      }

    } else {
      check = false;
      checkEmail = false;
      $('.check-email .error-1').removeClass('hide');    
      $('.check-email #ContactForm-email').addClass('error');   
    }

    if(email2 !== typeof undefined && email2 !== ''){

      if(IsEmail(email2)==false){
        check = false;
        checkEmail = false;
        $('.check-email .error-2').removeClass('hide');    
        $('.check-email #ContactForm-email02').addClass('error');   
      } else{
        $('.check-email .error-2').addClass('hide');   
        $('.check-email #ContactForm-email02').removeClass('error');
      }

    } else {
      check = false;
      checkEmail = false;
      $('.check-email .error-2').removeClass('hide');    
      $('.check-email #ContactForm-email02').addClass('error');   
    }

    if(checkEmail){
      if(email1 !== email2){
        check = false;
        $('.check-email .error-3').removeClass('hide');    
        $('.check-email #ContactForm-email02').addClass('error');  
      } else{
        $('.check-email .error-3').addClass('hide');    
        $('.check-email #ContactForm-email02').removeClass('error');  
      }
    } else{
      $('.check-email .error-3').addClass('hide');      
    }

    if(check){
      $('.check-email .attention').addClass('hide'); 
    } else{
      $('.check-email .attention').removeClass('hide');  
    }

    //CHECK CONTENT
    if(contents !== typeof undefined && contents !== ''){
      $('.check-contents .error-1').addClass('hide');   
      $('.check-contents #ContactForm-contents').removeClass('error');    
    } else {
      check = false;
      $('.check-contents .error-1').removeClass('hide');    
      $('.check-contents #ContactForm-contents').addClass('error');   
    }

    if(check){
      $('.check-contents .attention').addClass('hide'); 
    } else{
      $('.check-contents .attention').removeClass('hide');  
    }

    if(check){     
      $('input[type="submit"]').trigger( "click" );
    }

    e.preventDefault();    
  });

  //REVIEW
  $('.btn-write-review').on('click', function(e) {
    $(".fakebox-review").toggleClass('waiting');
    $('.fakebox-review-result').removeClass('active');
  });

  $('.btn-review-submmit').on('click', function(e) {
    var name = $(".fakebox-review input[name='reviewer_name']").val();
    var level = $(".fakebox-review select[name='recommend_level']").val();
    var title = $(".fakebox-review input[name='title']").val();
    var comment = $(".fakebox-review textarea[name='comment']").val();
    var email = $(".fakebox-review input[name='reviewer_email']").val();
    
    var reviewBox = $('#shopify-product-reviews');
    reviewBox.find("input[name*='author']").val(name);
    reviewBox.find("input[name*='email']").val(email);
    reviewBox.find("input[name*='rating']").val(level);
    reviewBox.find("input[name*='title']").val(title);
    reviewBox.find("textarea[name*='body']").val(comment);
    var check = true;

    if(name !== typeof undefined && name !== ''){
      $('.reviewer_name').removeClass('error');
    } else {
      check = false;
      $('.reviewer_name').addClass('error');
    }

    if(email !== typeof undefined && email !== ''){       

      if(IsEmail(email)==false){
        check = false;
        $('.reviewer_email').addClass('error');
      } else{
        $('.reviewer_email').removeClass('error');
      }

    } else {
      check = false;
      $('.reviewer_email').addClass('error');
    }
 
    if(level !== typeof undefined && level !== ''){
      $('.recommend_level').removeClass('error');
    } else {
      check = false;
      $('.recommend_level').addClass('error');
    }

    if(title !== typeof undefined && title !== ''){
      $('.reviewer_title').removeClass('error');
    } else {
      check = false;
      $('.reviewer_title').addClass('error');
    }

    if(comment !== typeof undefined && comment !== ''){
      $('.reviewer_comment').removeClass('error');
    } else { 
      check = false;
      $('.reviewer_comment').addClass('error');
    }

    if(check){
      $('.fakebox-review').addClass('waiting');
      $('.fakebox-review-result').addClass('active');
      reviewBox.find("input[type='submit']").trigger( "click" );
      $(".fakebox-review input[name='title']").val('');
      $(".fakebox-review textarea[name='comment']").val('');
      $(".fakebox-review input[name='reviewer_name']").val('');
      $(".fakebox-review input[name='reviewer_email']").val('');
    }

    e.preventDefault();    
  }); 


  //REGISTER 
  $('.register-page #customer-fields .action-button').on('click', function(e) {
    var xcheck = true;
    var xname1 = $("#customer-fields input[name='customer[last_name]']").val();
    var xname2 = $("#customer-fields input[name='customer[first_name]']").val();
    var xname3 = $("#customer-fields input[name='customer[last_name_kana]']").val();
    var xname4 = $("#customer-fields input[name='customer[first_name_kata]']").val();
    var xemail = $("#customer-fields input[name='customer[email]']").val();
    var xpassword = $("#customer-fields input[name='customer[password]']").val();
 

    if(xname1 !== typeof undefined && xname1 !== ''){
      $('.bug-1 > div.attention .er1').remove();
      $("#customer-fields input[name='customer[last_name]']").removeClass('bug');
    } else {
      var content = $('.bug-1 > div.attention').html();
      if($('.bug-1 > div.attention .er1').length){
        
      } else{     
        $('.bug-1 > div.attention').html('<span class="er1">※ お名前(姓)が入力されていません。<span>' + content);
        $("#customer-fields input[name='customer[last_name]']").addClass('bug');
      }
      xcheck = false; 
    };

    if(xname2 !== typeof undefined && xname2 !== ''){
      $('.bug-1 > div.attention .er2').remove(); 
      $("#customer-fields input[name='customer[first_name]']").removeClass('bug');
    } else {
      var content = $('.bug-1 > div.attention').html();

      if($('.bug-1 > div.attention .er2').length){
        
      } else{ 
        $('.bug-1 > div.attention').html(content + '<span class="er2">※ お名前(名)が入力されていません。<span>');      
        $("#customer-fields input[name='customer[first_name]']").addClass('bug');
      }
      xcheck = false; 
    }


    if(xname3 !== typeof undefined && xname3 !== ''){
      $('.bug-2 > div.attention .er1').remove(); 

      if(wanakana.isKatakana(xname3)){
        $('.bug-2 > div.attention .er3').remove(); 
        $("#customer-fields input[name='customer[last_name_kana]']").removeClass('bug');

      }else{
        var content = $('.bug-2 > div.attention').html();

        if($('.bug-2 > div.attention .er3').length){
          
        } else{ 
          $('.bug-2 > div.attention').html(content + '<span class="er3">※ お名前(フリガナ・姓)はカタカナで入力してください。<span>');      
          $("#customer-fields input[name='customer[last_name_kana]']").addClass('bug');
        }

        xcheck = false; 
      }

    } else {
      var content = $('.bug-2 > div.attention').html();

      if($('.bug-2 > div.attention .er1').length){
        
      } else{ 
        $('.bug-2 > div.attention').html(content + '<span class="er1">※ お名前(フリガナ・姓)が入力されていません。<span>');      
        $("#customer-fields input[name='customer[last_name_kana]']").addClass('bug');
      }
      xcheck = false; 
    }

    if(xname4 !== typeof undefined && xname4 !== ''){
      $('.bug-2 > div.attention .er2').remove(); 

      if(wanakana.isKatakana(xname4)){
        $('.bug-2 > div.attention .er4').remove(); 
        $("#customer-fields input[name='customer[first_name_kata]']").removeClass('bug');

      }else{
        var content = $('.bug-2 > div.attention').html();

        if($('.bug-2 > div.attention .er4').length){
          
        } else{ 
          $('.bug-2 > div.attention').html(content + '<span class="er4">※ お名前(フリガナ・名)はカタカナで入力してください。<span>');      
          $("#customer-fields input[name='customer[first_name_kata]']").addClass('bug');
        }

        xcheck = false; 
      }

    } else {
      var content = $('.bug-2 > div.attention').html();

      if($('.bug-2 > div.attention .er2').length){
        
      } else{ 
        $('.bug-2 > div.attention').html(content + '<span class="er2">※ お名前(フリガナ・名)が入力されていません。<span>');      
        $("#customer-fields input[name='customer[first_name_kata]']").addClass('bug');
      }
      xcheck = false; 
    }

    if(xemail !== typeof undefined && xemail !== ''){
      $('.bug-3 > div.attention .er1').remove(); 

      if(IsEmail(xemail)){
        $('.bug-3 > div.attention .er4').remove(); 
        $("#customer-fields input[name='customer[email]']").removeClass('bug');

      }else{
        var content = $('.bug-3 > div.attention').html();

        if($('.bug-3 > div.attention .er4').length){
          
        } else{ 
          $('.bug-3 > div.attention').html(content + '<span class="er4">※ メールアドレスの形式が不正です。<span>');      
          $("#customer-fields input[name='customer[email]']").addClass('bug');
        }
        xcheck = false; 
      }
    } else {
      var content = $('.bug-3 > div.attention').html();

      if($('.bug-3 > div.attention .er1').length){
        
      } else{ 
        $('.bug-3 > div.attention').html(content + '<span class="er1">※ メールアドレスが入力されていません。<span>');      
        $("#customer-fields input[name='customer[email]']").addClass('bug');
      }
      xcheck = false; 
    }

    if(xpassword !== typeof undefined && xpassword !== ''){
      $('.bug-4 > div.attention .er1').remove(); 

      if( xpassword.length > 7 && xpassword.length < 51){
        $('.bug-4 > div.attention .er2').remove(); 
        $("#customer-fields input[name='customer[password]']").removeClass('bug');

      } else{
        var content = $('.bug-4 > div.attention').html();

        if($('.bug-4 > div.attention .er2').length){
          
        } else{ 
          $('.bug-4 > div.attention').html(content + '<span class="er2">半角英数字8～50文字でお願いします。（記号可）<span>');      
          $("#customer-fields input[name='customer[password]']").addClass('bug');
        }
        xcheck = false;         
      }

    } else {
      var content = $('.bug-4 > div.attention').html();

      if($('.bug-4 > div.attention .er1').length){
        
      } else{ 
        $('.bug-4 > div.attention').html(content + '<span class="er1">※ パスワードが入力されていません。<span>');      
        $("#customer-fields input[name='customer[password]']").addClass('bug');
      }
      xcheck = false; 
    }

    if(xcheck){
      $(this).closest('form').submit();
    }

    e.preventDefault();    
  });


  //EDIT
  $('.account-edit #create_customer .action-button').on('click', function(e) {

    var xcheck = true;
    var xname1 = $("#customer-fields input[name='customer[last_name]']").val();
    var xname2 = $("#customer-fields input[name='customer[first_name]']").val();
    var xname3 = $("#customer-fields input[name='customer[last_name_kana]']").val();
    var xname4 = $("#customer-fields input[name='customer[first_name_kata]']").val();
    var xemail = $("#customer-fields input[name='customer[email]']").val();

    if(xname1 !== typeof undefined && xname1 !== ''){
      $('.bug-1 > div.attention .er1').remove();
      $("#customer-fields input[name='customer[last_name]']").removeClass('bug');
    } else {
      var content = $('.bug-1 > div.attention').html();
      if($('.bug-1 > div.attention .er1').length){
        
      } else{     
        $('.bug-1 > div.attention').html('<span class="er1">※ お名前(姓)が入力されていません。<span>' + content);
        $("#customer-fields input[name='customer[last_name]']").addClass('bug');
      }
      xcheck = false; 
    };

    if(xname2 !== typeof undefined && xname2 !== ''){
      $('.bug-1 > div.attention .er2').remove(); 
      $("#customer-fields input[name='customer[first_name]']").removeClass('bug');
    } else {
      var content = $('.bug-1 > div.attention').html();

      if($('.bug-1 > div.attention .er2').length){
        
      } else{ 
        $('.bug-1 > div.attention').html(content + '<span class="er2">※ お名前(名)が入力されていません。<span>');      
        $("#customer-fields input[name='customer[first_name]']").addClass('bug');
      }
      xcheck = false; 
    }


    if(xname3 !== typeof undefined && xname3 !== ''){
      $('.bug-2 > div.attention .er1').remove(); 

      if(wanakana.isKatakana(xname3)){
        $('.bug-2 > div.attention .er3').remove(); 
        $("#customer-fields input[name='customer[last_name_kana]']").removeClass('bug');

      }else{
        var content = $('.bug-2 > div.attention').html();

        if($('.bug-2 > div.attention .er3').length){
          
        } else{ 
          $('.bug-2 > div.attention').html(content + '<span class="er3">※ お名前(フリガナ・姓)はカタカナで入力してください。<span>');      
          $("#customer-fields input[name='customer[last_name_kana]']").addClass('bug');
        }

        xcheck = false; 
      }

    } else {
      var content = $('.bug-2 > div.attention').html();

      if($('.bug-2 > div.attention .er1').length){
        
      } else{ 
        $('.bug-2 > div.attention').html(content + '<span class="er1">※ お名前(フリガナ・姓)が入力されていません。<span>');      
        $("#customer-fields input[name='customer[last_name_kana]']").addClass('bug');
      }
      xcheck = false; 
    }

    if(xname4 !== typeof undefined && xname4 !== ''){
      $('.bug-2 > div.attention .er2').remove(); 

      if(wanakana.isKatakana(xname4)){
        $('.bug-2 > div.attention .er4').remove(); 
        $("#customer-fields input[name='customer[first_name_kata]']").removeClass('bug');

      }else{
        var content = $('.bug-2 > div.attention').html();

        if($('.bug-2 > div.attention .er4').length){
          
        } else{ 
          $('.bug-2 > div.attention').html(content + '<span class="er4">※ お名前(フリガナ・名)はカタカナで入力してください。<span>');      
          $("#customer-fields input[name='customer[first_name_kata]']").addClass('bug');
        }

        xcheck = false; 
      }

    } else {
      var content = $('.bug-2 > div.attention').html();

      if($('.bug-2 > div.attention .er2').length){
        
      } else{ 
        $('.bug-2 > div.attention').html(content + '<span class="er2">※ お名前(フリガナ・名)が入力されていません。<span>');      
        $("#customer-fields input[name='customer[first_name_kata]']").addClass('bug');
      }
      xcheck = false; 
    }

    if(xemail !== typeof undefined && xemail !== ''){
      $('.bug-3 > div.attention .er1').remove(); 

      if(IsEmail(xemail)){
        $('.bug-3 > div.attention .er4').remove(); 
        $("#customer-fields input[name='customer[email]']").removeClass('bug');

      }else{
        var content = $('.bug-3 > div.attention').html();

        if($('.bug-3 > div.attention .er4').length){
          
        } else{ 
          $('.bug-3 > div.attention').html(content + '<span class="er4">※ メールアドレスの形式が不正です。<span>');      
          $("#customer-fields input[name='customer[email]']").addClass('bug');
        }
        xcheck = false; 
      }
    } else {
      var content = $('.bug-3 > div.attention').html();

      if($('.bug-3 > div.attention .er1').length){
        
      } else{ 
        $('.bug-3 > div.attention').html(content + '<span class="er1">※ メールアドレスが入力されていません。<span>');      
        $("#customer-fields input[name='customer[email]']").addClass('bug');
      }
      xcheck = false; 
    }


    if(xcheck){
      $(this).closest('form').submit();
    }

    e.preventDefault();    

  });



  function IsEmail(email) {
    var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(!regex.test(email)) {
      return false;
    }else{
      return true;
    }
  }
  
  var previous_url = Cookies.get('recent_link');
  if (!['/','/cart'].includes(previous_url)){
  } else {
    $('#return').css('display','none');
  }
  $('#return').on('click',function(){
    window.location.assign(previous_url);
  });
  Cookies.set('recent_link', window.location.pathname);  
})


/********************************************************
# SWIPER CAROUSEL
********************************************************/

jQuery(document).ready(function(){
  $(".swiper-container").not(".swiper-container-recently-viewed").each( function(){
    var xs_item = $(this).attr('data-xs');
    var sm_item = $(this).attr('data-sm');
    var md_item = $(this).attr('data-md');
    var datarow = $(this).attr('data-row');   
    var direction = $(this).attr('data-direction');   
    var loop = $(this).attr('data-loop'); 


    if (typeof xs_item !== typeof undefined && xs_item !== false) {    
    } else{
      xs_item = 1;
    }

    if (typeof sm_item !== typeof undefined && sm_item !== false) {    
    } else{
      sm_item = 2;
    }

    if (typeof md_item !== typeof undefined && md_item !== false) {    
    } else{
      md_item = 3;
    }

    if (typeof datarow !== typeof undefined && datarow !== false) {    
    } else{
      datarow = 1;
    }


    if (typeof direction !== typeof undefined && direction !== false) {    
    } else{
      direction = 'horizontal';
    }

    if (typeof loop !== typeof undefined && loop == "true") {    
      loop = true;
    } else{
      loop = false;
    }


    var config = {
      spaceBetween: $(this).data('margin'),
      slidesPerView: $(this).data('items'),
      direction: direction,
      slidesPerColumn: datarow,
      paginationClickable: true,
      loop: loop,

      pagination: {
        el: $(this).find('.swiper-pagination'),
        clickable: true,
      },

      navigation: {
        nextEl: $(this).find('.swiper-button-next'),
        prevEl: $(this).find('.swiper-button-prev'),
      },

      scrollbar: {
        el: $(this).find('.swiper-scrollbar'),
      },

      breakpoints: {
        320: {
          slidesPerView: xs_item,
          spaceBetween: 10
        },

        480: {
          slidesPerView: xs_item,
          spaceBetween: 12
        },

        768: {
          slidesPerView: sm_item,
          spaceBetween: 14
        },

        980: {
          slidesPerView: md_item,
          spaceBetween: 16
        }
      }
    };		
    var swiper = new Swiper(this, config);
  });
});

function loadCarouselRecent(){
  $(".swiper-container-recently-viewed, #happy_recipe").each( function(){
    var xs_item = $(this).attr('data-xs');
    var sm_item = $(this).attr('data-sm');
    var md_item = $(this).attr('data-md');
    var datarow = $(this).attr('data-row');
    var direction = $(this).attr('data-direction');
    var loop = $(this).attr('data-loop');


    if (typeof xs_item !== typeof undefined && xs_item !== false) {
    } else{
      xs_item = 1;
    }

    if (typeof sm_item !== typeof undefined && sm_item !== false) {
    } else{
      sm_item = 2;
    }

    if (typeof md_item !== typeof undefined && md_item !== false) {
    } else{
      md_item = 3;
    }

    if (typeof datarow !== typeof undefined && datarow !== false) {
    } else{
      datarow = 1;
    }


    if (typeof direction !== typeof undefined && direction !== false) {
    } else{
      direction = 'horizontal';
    }

    if (typeof loop !== typeof undefined && loop == "true") {
      loop = true;
    } else{
      loop = false;
    }


    var config = {
      spaceBetween: $(this).data('margin'),
      slidesPerView: $(this).data('items'),
      direction: direction,
      slidesPerColumn: datarow,
      paginationClickable: true,
      loop: loop,

      pagination: {
        el: $(this).find('.swiper-pagination'),
        clickable: true,
      },

      navigation: {
        nextEl: $(this).find('.swiper-button-next'),
        prevEl: $(this).find('.swiper-button-prev'),
      },

      scrollbar: {
        el: $(this).find('.swiper-scrollbar'),
      },

      breakpoints: {
        320: {
          slidesPerView: xs_item,
          spaceBetween: 10
        },

        480: {
          slidesPerView: xs_item,
          spaceBetween: 12
        },

        768: {
          slidesPerView: sm_item,
          spaceBetween: 14
        },

        980: {
          slidesPerView: md_item,
          spaceBetween: 16
        }
      }
    };
    var swiper2 = new Swiper(this, config);
    $(this).addClass('active');
  });
}


